import { ApiAdminCompaniesResponseData } from './types';
import { ICompany } from 'src/models/company/types';
import { Company } from 'src/models/company';

export class AdminCompaniesData {
  readonly count: number;
  readonly companies: ICompany[];

  constructor(private readonly apiCompaniesResponse: ApiAdminCompaniesResponseData) {
    this.count = apiCompaniesResponse.count;
    this.companies = this.toCompaniesData();
  }

  private toCompaniesData(): ICompany[] {
    const apiCompanies = this.apiCompaniesResponse.companies || [];
    return apiCompanies.map(company => new Company(company));
  }
}
